import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import useBoolean from "@hooks/useBoolean";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import useSubmissionSource from "@hooks/useSubmissionSource";
var FinanceDisqualified = function FinanceDisqualified() {
  var dialog = useBoolean(false);
  var _useSubmissionSource = useSubmissionSource(),
    setSubmissionSource = _useSubmissionSource.setSubmissionSource;
  var layoutOptions = {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: false,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    headHideLinks: true,
    backgroundColor: "bg-gray-lotion",
    custommobileHeader: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid min-h-[70px]"
    }))
  };
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, layoutOptions, /*#__PURE__*/React.createElement("div", {
    className: "lg:max-w-[665px] lg:mx-auto  lg:bg-white lg:rounded-2xl lg:shadow-xl lg:mt-20 lg:border lg:border-solid lg:border-gray-lotion lg:py-10"
  }, /*#__PURE__*/React.createElement("section", {
    className: "bg-gray-lotion px-6 min-h-[calc(100vh-70px)] pt-16 lg:bg-transparent lg:p-0 lg:min-h-[unset] lg:max-w-[350px] lg:mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/disqualified.png",
    alt: "Finance disqualified illustration"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 mb-7 flex flex-col items-center gap-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary font-bold text-2xl text-center"
  }, t("eligible_financing", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-primary font-semibold text-base"
  }, t("check_financing_requirements_know_what", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer p-3 rounded bg-primary border-0 outline-none text-white text-sm font-bold leading-8",
    onClick: function onClick() {
      trackEvents("finance_requirements_open", {
        referral_location: "eligibility"
      });
      dialog.setTrue();
    }
  }, t("learn_financing_requirements", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer p-3 rounded bg-transparent border border-solid border-primary outline-none text-primary text-sm font-bold leading-8",
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, t("browse_cars_2", {
    ns: "web_common"
  }))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: dialog.value,
    onClose: dialog.setFalse
  }, /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null))));
};
export default FinanceDisqualified;